var $a41434a97f5222d7$exports = {};
$a41434a97f5222d7$exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};


export {$a41434a97f5222d7$exports as default};
//# sourceMappingURL=es-ES.module.js.map
